function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(1.42 1.42)"
}, React.createElement("path", {
  fill: "#DDFBE0",
  d: "M9.823 19.645C4.398 19.645 0 15.247 0 9.823 0 4.398 4.398 0 9.823 0c5.424 0 9.822 4.398 9.822 9.823 0 5.424-4.398 9.822-9.822 9.822z"
})), React.createElement("path", {
  fill: "#1BE12F",
  d: "M11 1.646a9.354 9.354 0 1 0 0 18.708 9.354 9.354 0 0 0 0-18.708zM.709 11C.709 5.316 5.316.709 10.999.709c5.684 0 10.292 4.607 10.292 10.29 0 5.684-4.608 10.292-10.291 10.292C5.316 21.29.709 16.683.709 11z"
}), React.createElement("g", {
  transform: "translate(3.548 11.355)"
}, React.createElement("path", {
  fill: "#1BE12F",
  d: "M13.294 1.544a22.95 22.95 0 0 1-11.846.007 7.354 7.354 0 0 0 1.331 2.833C3.691 5.548 5.142 6.56 7.451 6.56c2.308 0 3.725-1.015 4.598-2.178.76-1.013 1.114-2.147 1.245-2.838zm.054-.985a.728.728 0 0 1 .925.784v.001c-.086.73-.461 2.25-1.475 3.6-1.029 1.37-2.71 2.553-5.347 2.553-2.633 0-4.344-1.174-5.41-2.535C.992 3.62.572 2.105.462 1.37l.464-.07-.463.071a.728.728 0 0 1 .921-.809A22.036 22.036 0 0 0 13.348.56z"
})), React.createElement("g", {
  transform: "translate(4.258 13.484)"
}, React.createElement("path", {
  fill: "#1BE12F",
  d: "M12.73.634C8.548 2.002 4.506 2.027.623.634l1.665 2.564L5.84 4.963 8.65 4.9l2.534-1.747L12.73.633z"
})), React.createElement("g", {
  transform: "translate(12.065 7.097)"
}, React.createElement("path", {
  fill: "#1BE12F",
  d: "M1.803.025c1.957 0 1.606 3.447 1.365 3.447-.24 0-.408-1.38-1.365-1.38-.956 0-1.068 1.421-1.399 1.421-.332 0-.557-3.488 1.399-3.488z"
})), React.createElement("g", {
  transform: "translate(6.387 7.097)"
}, React.createElement("path", {
  fill: "#1BE12F",
  d: "M1.614.025C-.343.025.008 3.472.25 3.472c.24 0 .407-1.38 1.364-1.38.957 0 1.069 1.421 1.399 1.421.332 0 .558-3.488-1.399-3.488z"
})));

var SvgHappy = function SvgHappy(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHappy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Happy.e0e03aad.svg";
export { ForwardRef as ReactComponent };